import React, { useMemo } from "react";
import PropTypes from "prop-types";

import Filter from "../../../Filter";

const EvaluationRoundsFilters = ({
  copy,
  search,
  filters,
  statusOptions,
  renderActionBeforeFilterToggle,
  onSearchChange,
  onFilterChange,
}) => {
  const filterItems = useMemo(
    () => [
      {
        type: "filter",
        name: "status",
        placeholder: copy.filterStatus,
        value: filters.status,
        options: statusOptions,
        onChange: (value) => onFilterChange("status", value),
      },
      {
        type: "date",
        name: "evaluationRoundStartDate",
        label: copy.filterStartDate,
        placeholder: copy.filterStartDate,
        value: filters.startDate,
        onChange: (value) => onFilterChange("startDate", value),
      },
      {
        type: "date",
        name: "evaluationRoundEndDate",
        label: copy.filterEndDate,
        placeholder: copy.filterEndDate,
        value: filters.endDate,
        onChange: (value) => onFilterChange("endDate", value),
      },
    ],
    [copy, filters, statusOptions, onFilterChange],
  );

  return (
    <Filter
      searchInput={{
        placeholder: copy.searchPlaceholder,
        name: "evaluationRoundSearch",
        value: search,
        onChange: onSearchChange,
      }}
      renderActionBeforeFilterToggle={renderActionBeforeFilterToggle}
      filters={filterItems}
    />
  );
};

EvaluationRoundsFilters.propTypes = {
  copy: PropTypes.shape({
    searchPlaceholder: PropTypes.string.isRequired,
    filterStatus: PropTypes.string.isRequired,
    filterStartDate: PropTypes.string.isRequired,
    filterEndDate: PropTypes.string.isRequired,
  }).isRequired,
  search: PropTypes.string.isRequired,
  filters: PropTypes.shape({
    status: PropTypes.object,
    startDate: PropTypes.any,
    endDate: PropTypes.any,
  }).isRequired,
  statusOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  renderActionBeforeFilterToggle: PropTypes.node,
  onSearchChange: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
};

EvaluationRoundsFilters.defaultProps = {
  renderActionBeforeFilterToggle: null,
};

export default EvaluationRoundsFilters;
